export const MICROAPP_NAME = "ai_firewall";

export const MAIN_ROUTE_AI_FW = "/insights/ai-security";
export const MAIN_ROUTE_AI_FW_V3 = "/insights/ai-security";
